import BaseService from "./_base-service";
import ax from '@shared/axios';

class ProjectDashboardService extends BaseService {
   searchList(params: object) {
      return this.resource$.post<any>(`/wms-app/project-dashboard/searchByPaging`, params);
   }

   updateList(params: object) {
      return this.resource$.post<any>(`/report-center/marketplace/item-batch-update`, params);
   }

   export(params: object) {
      return ax.post(`/wms-app/report/export`, params, {
         responseType: 'arraybuffer'
      });
   }

   customerApproval(params: any) {
      const {id, customerApprovalStatus} = params;
      return this.resource$.post<any>(`/wms-app/project-dashboard/customerApproval/${id}`, {customerApprovalStatus: customerApprovalStatus});
   }

   getProjectDashboardView(id: string) {
      return this.resource$.get<any>(`/wms-app/project-dashboard/${id}`);
   }

}

let projectDashboardService =  new ProjectDashboardService();
export default projectDashboardService;